import React, {useCallback} from 'react';
import {TextField} from '@mui/material';
import {removeInitialSpecialChars} from '../../../../util/sanitizeUtil';
import {CheckInFieldProps} from '../interfaces';
import {CODE_INPUT_PROPS} from './keyboardInputProps';

/**
 * Trailer Number text field.
 * Uppercases and sanitizes input on every keystroke.
 */
const TrailerNumberField: React.FC<CheckInFieldProps> = ({value, onValueChange, error, required}) => {
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = removeInitialSpecialChars(e.target.value.toUpperCase());
    onValueChange('trailerNumber', sanitized);
  }, [onValueChange]);

  return (
    <TextField
      id="trailerNumber"
      name="trailerNumber"
      label="Trailer Number"
      value={value}
      onChange={handleChange}
      placeholder="Enter the trailer number"
      variant="standard"
      fullWidth
      required={required}
      error={!!error}
      helperText={error}
      inputProps={{...CODE_INPUT_PROPS, 'aria-label': 'Trailer Number'}}
    />
  );
};

export default TrailerNumberField;

